
@switch (this.dialogType()) {
    @case ('TIME_ZONE') {
        <div class="countable-dialog w-100" style="max-width: 400px;">
            <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info"></i>
            </span>
                <h4 class="title text-center">Time Zone Update</h4>
            </div>
            <div mat-dialog-content class="content dialog-body-content text-center gap-16 mt-2 mb-32">

                <p class="text-gray-6"> We've detected a time zone mismatch, which may affect displayed information</p>
                <p class="align-items-start bg-gray-1 br-6 p-1">
                    Default Time Zone: {{timeZone()?.zoneNameUi}}
                </p>
                <p class="text-gray-6">Do you wish to update the time zone or keep the default?
                </p>
            </div>
            <div mat-dialog-actions class="dialog-footer button-group">
                <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]="false">Keep
                    Default
                </button>
                <button [mat-dialog-close]="true" mat-button mat-flat-button color="primary" class="button-defalut">Update
                    Time Zone
                </button>
            </div>
        </div>
    }
    @case ("LETTER") {
        <div class="countable-dialog mh-100 h-100 right-drawer-dialog letter-right-dialog">
            <div mat-dialog-title class="dialog-header px-3">
                <h4 class="title">Select letter template</h4>
                <button mat-button class="close" [mat-dialog-close]="false">
                    <i class="fa-regular fa-xmark clear-icon"></i>
                </button>
            </div>

            <div mat-dialog-content class="dialog-body-content template-block-main p-0 pt-3">
                <div class="template-block-main">
                    <mat-tab-group (selectedIndexChange)="onChangeTabSections($event)">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Firm templates
                            </ng-template>
                            <ng-template matTabContent>
                                <div class="search-block gap-20">
                                    <mat-form-field class="fixed-label label-none flex-1 icon-form-before" floatlabel="always">
                                        <mat-label>Search</mat-label>
                                        <input matInput placeholder="Search" [formControl]="searchCtrl" maxlength="25">
                                        <span matPrefix>
                                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                                </span>
                                    </mat-form-field>
                                </div>

                                <mat-accordion class="templates-list" #accordion="matAccordion" multi="true">
                                    @for(folder of firmTemplates();track $index){
                                        <mat-expansion-panel [expanded]="folder.isexpand == 'true'">
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <div class="title-content"
                                                         title="{{folder.foldername}} ({{folder.templates ? folder.templates.length : 0}} letters)">
                                            <span class="togglable-icon">
                                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                            </span>
                                                        <span class="item-icon">
                                                <img src="/assets/images/ui-uplift-icons/global/colored-folder-icon.svg"
                                                     alt="icon">
                                            </span>
                                                        <p class="item-title" style="max-width: 250px;">{{folder.foldername}}</p>
                                                    </div>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>

                                            <ng-container *ngIf="folder.templates">
                                                <mat-list role="list" class="templates-list-items">
                                                    @for(template of folder.templates;track $index){
                                                        <mat-list-item role="listitem" title="{{template.TemplateName}}">

                                            <span class="list-item-content"
                                                  [ngStyle]="{'background-color': template.ishighlight === 'true' ? '#D8ECFE' : ''}"
                                                  [ngClass]="{'disabled': template?.isDisabled }"
                                                  (click)="addTemplate(template,'firm')" [mat-dialog-close]="true">
                                                <span class="item-icon">
                                                    <img src="/assets/images/icons/letters-icon.svg" alt="icon" />
                                                </span>
                                                <span class="item-title">{{template.TemplateName}}</span>
                                                <span class="set-default-dot" *ngIf="template.is_default === 1"></span>
                                            </span>
                                                        </mat-list-item>
                                                    }
                                                </mat-list>
                                            </ng-container>
                                        </mat-expansion-panel>
                                    }
                                </mat-accordion>


                            </ng-template>
                        </mat-tab>


                        <mat-tab [disabled]="!hasPegPact()">
                            <ng-template mat-tab-label>
                                <span>Master library</span>
                            </ng-template>
                            <ng-template matTabContent>
                                <div class="search-block gap-20">
                                    <mat-form-field class="fixed-label label-none flex-1 icon-form-before" floatlabel="always">
                                        <mat-label>Search</mat-label>
                                        <input matInput placeholder="Search" [formControl]="searchCtrl" maxlength="25">
                                        <span matPrefix>
                                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                                </span>
                                    </mat-form-field>
                                </div>
                                <mat-accordion class="templates-list" #accordion="matAccordion" multi="true">
                                    @for(folder of masterLibrary();track $index) {
                                        <mat-expansion-panel [expanded]="folder.isexpand == 'true'">
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <div class="title-content" title="{{folder.StandardName}}">
                                            <span class="togglable-icon">
                                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                            </span>
                                                        <span class="item-icon">
                                                <img src="/assets/images/ui-uplift-icons/global/colored-folder-icon.svg"
                                                     alt="icon">
                                            </span>
                                                        <p class="item-title" style="max-width: 250px;">{{folder.StandardName}}</p>
                                                    </div>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>
                                            <ng-container *ngIf="folder.template">
                                                <mat-list role="list" class="templates-list-items">
                                                    <mat-list-item role="listitem" *ngFor="let template of folder.template;"
                                                                   title="{{template?.templatename}}"
                                                                   [ngClass]="{'disabled': template?.isDisabled }"
                                                                   [ngStyle]="{'background-color': template.ishighlight === 'true' ? '#D8ECFE' : ''}">
                                                        <ng-container>
                                                <span class="list-item-content" (click)="addTemplate(template,'master')"
                                                      [mat-dialog-close]="true">
                                                    <span class="item-icon">
                                                        <img src="/assets/images/icons/letters-icon.svg" alt="icon" />
                                                    </span>
                                                    <span class="item-title">{{template?.templatename}}</span>
                                                    <span class="set-default-dot" *ngIf="template?.is_default === 1">
                                                    </span>
                                                </span>
                                                        </ng-container>
                                                    </mat-list-item>
                                                </mat-list>
                                            </ng-container>
                                        </mat-expansion-panel>
                                    }
                                </mat-accordion>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
    }
}
